import { render, staticRenderFns } from "./M3Replays.vue?vue&type=template&id=5ddc36b7&scoped=true&"
import script from "./M3Replays.vue?vue&type=script&lang=js&"
export * from "./M3Replays.vue?vue&type=script&lang=js&"
import style0 from "./M3Replays.vue?vue&type=style&index=0&id=5ddc36b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddc36b7",
  null
  
)

export default component.exports